import styled from "styled-components";

export const MessagePageStyle = styled.div`
  .custom-message {
    height: 150px;
    font-family: thin-pro, sans-serif;
  }

  .form-floating {
    width: 100%;
    margin-bottom: 20px;
  }

  .form-button-disable {
    background-color: #bcb7b7;
  }

  .message-div {
    align-self: center;
    display: flex;
    align-items: baseline;
    width: 40%;
    margin-top: 20px;
  }
  h6 {
    margin-right: 5px;
  }

  .radio-div {
    align-self: center;
    display: flex;
    justify-content: space-between;
    width: 500px;
    font-family: thin-pro, sans-serif;
    margin-bottom: 30px;
  }
  .radio-div2 {
    align-self: center;
    display: flex;
    width: 500px;
    font-family: thin-pro, sans-serif;
    margin-bottom: 30px;
  }

  .form-check-input:checked {
    background-color: #f28809;
    border-color: #f28809;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background-color: #f28809;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled {
    background-color: #f28809;
  }

  .form-button {
    width: 20vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 50px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
    align-self: center;
  }

  .subscription-box {
    display: flex;
    align-self: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 50px;
  }

  .menu2 {
    width: 100%;
  }

  .dropdown {
    font-family: thin-pro, sans-serif;
  }
  .dropDown-custom {
    width: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .someUser-box {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 2vh 3.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 70vh;
    height: 500px;
    margin-top: 3vh;
    overflow-wrap: anywhere;
    align-self: center;
    overflow-y: scroll;
    font-family: thin-pro, sans-serif;
  }

  .search-bar {
    display: flex;
    align-items: center;
    border: 1px solid #f28809;
    border-radius: 20px;
    width: 100%;
    background-color: white;
    padding: 0 15px 0 5px;
    margin-bottom: 10px;
  }

  .search-input {
    flex: 1;
    border: none;
    outline: none;
    padding: 5px;
    border-radius: 20px;
  }

  .form-check {
    display: flex;
    justify-content: flex-start;
    align-items: unset;
  }
  .form-check2 {
    display: flex;
    justify-content: flex-start;
    align-items: unset;
    margin-right: 50px;
  }

  .form-check-label {
    margin-left: 15px;
    font-family: thin-pro, sans-serif;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    /* color: var(--bs-dropdown-link-hover-color); */
    color: white;
    /* background-color: var(--bs-dropdown-link-hover-bg); */
    background-color: #ed9e44;
    cursor: pointer;
  }
  .search-icon {
    color: #f28809;
    font-size: 20px;
    cursor: pointer;
  }

  .date-selection {
    align-self: center;
    display: flex;
    width: 50%;
    margin-bottom: 30px;
  }

  .table-div {
    width: 40%;
    align-self: center;
    margin: 20px 0;
  }

  .field {
    display: flex;
    justify-content: end;
    font-family: medium-pro, sans-serif;
  }

  .react-datetime-picker__button:enabled:hover
    .react-datetime-picker__button__icon,
  .react-datetime-picker__button:enabled:focus
    .react-datetime-picker__button__icon {
    stroke: #f28809;
  }

  .date-div {
    margin-bottom: 30px;
  }

  .react-datetime-picker__wrapper {
    border: thin solid #dee2e6;
    border-radius: 5px;
  }

  .warning {
    color: grey;
    margin-bottom: 0;
    text-align: end;
    font-size: 0.8rem;
  }
`;
